import PhaseTabs from '../components/phase-tabs';
import { docReady } from '../utils/docReady';
// We had to remove the register functionality from slate as it causes conflicts with sections anywhere.
docReady(() => {
    const sections = document.querySelectorAll('[data-section-type="phase-tabs"]');
    if (sections.length > 0) {
        [...sections].forEach((section) => {
            const tabs = new PhaseTabs(section);
        });
    }
});
